module.exports = __webpack_public_path__ + "media/images/home/ic_events-852d04dfaf8a23d8d77b3b3d6abd2ea6.svg";